// extracted by mini-css-extract-plugin
export default {"legalSection":"LegalNoticePage_legalSection__PeeIm","title":"LegalNoticePage_title__glysk","article":"LegalNoticePage_article__t2txC"};